import { useQuery } from '@tanstack/react-query';

import { getFavoritesApi, getProductsByIdsApi } from '../api/favoritesApi';

export const favoritesQueryKeys = {
  all: ['favorites'] as const,
  list: () => [...favoritesQueryKeys.all, 'list'] as const,
  guestListByIds: (ids: number[]) =>
    [...favoritesQueryKeys.all, 'guest-list-by-ids', ...ids] as const,
};

export const useFavoritesQuery = (enabled: boolean) => {
  return useQuery({
    queryKey: favoritesQueryKeys.list(),
    queryFn: () => getFavoritesApi(),
    enabled,
  });
};

export const useGuestFavoritesProductsQuery = (ids: number[], enabled: boolean) => {
  return useQuery({
    queryKey: favoritesQueryKeys.guestListByIds(ids),
    queryFn: () => getProductsByIdsApi({ ids }),
    enabled: enabled && ids.length > 0,
  });
};
